import { get, post1 } from '../request.js'
// import request from '../request.js'

// 实名认证接口
export const obtainAuthenticationInfoByMobile = (data) => {
  return get('/api/tms/account/obtainAuthenticationInfoByMobile', data)
}

// 修改密码接口
export const changePassword = (data) => {
  return post1('/api/tms/account/changePassword', data)
}

// 修改账户信息接口
export const authenticationWhoName = (data) => {
  return post1('/api/tms/account/authenticationWhoName', data)
}

// 获取用户信息
export const userInfo = () => {
  return get('/api/tms/account/userInfo')
}
